<template>
  <div class="pb-2">
    <div class="float-left mb-2">
      <button class="mipe-calendar-btn mr-4" @click="getPreviousWeek()">
        <i class="fa fa-chevron-left" />
      </button>
      <label class="calendar-filter-text">
        {{ firstDayNumber }} - {{ lastDayNumber }} {{ monthName | capitalize }}
      </label>
      <button class="mipe-calendar-btn ml-4" @click="getNextWeek()">
        <i class="fa fa-chevron-right" />
      </button>
    </div>
    <div class="float-right mb-2">
      <CustomDatePicker
        placeholder="Seleccione Día"
        right
        @onSelectedDate="(data) => $emit('onSelectedDate', data)"
      />
    </div>
  </div>
</template>
<script>
import CustomDatePicker from '@/components/common/CustomDatePicker';
import moment from 'moment';

export default {
  meta: {
    description: 'Componente común, filtros de calendario semanal.',
    slots: {
      default: {
        type: 'component',
        valid: [],
      },
    },
  },
  components: {
    CustomDatePicker,
  },
  props: {
    days: {
      type: Array,
      default: () => {
        return [{ id: 1, text: '', isSelected: false }];
      },
      meta: {
        description: 'Propiedad para los días del calendario',
        example: '[4, 8, 15, 16, 23, 42]',
      },
    },
  },
  methods: {
    getNextWeek() {
      let lastDay = moment(this.lastDay.date);
      const startDate = lastDay.add(1, 'd').format('YYYY-MM-DD');
      const endDate = lastDay.add(6, 'd').format('YYYY-MM-DD');

      this.$emit('change-week', { startDate: startDate, endDate: endDate });
    },
    getPreviousWeek() {
      let firstDay = moment(this.firstDay.date);
      const endDate = firstDay.subtract(1, 'd').format('YYYY-MM-DD');
      const startDate = firstDay.subtract(6, 'd').format('YYYY-MM-DD');

      this.$emit('change-week', { startDate: startDate, endDate: endDate });
    },
  },
  computed: {
    firstDayNumber() {
      if (this.days.length === 0) return '';
      return this.days[0].dayNumber;
    },
    firstDay() {
      if (this.days.length === 0) return {};
      return this.days[0];
    },
    lastDay() {
      if (this.days.length === 0) return {};
      return this.days[this.days.length - 1];
    },
    lastDayNumber() {
      return this.lastDay.dayNumber;
    },
    monthName() {
      let dayName = moment(this.lastDay.date).format('MMMM');
      return dayName;
    },
  },
};
</script>

<style>
.mipe-calendar-btn {
  width: 30px;
  height: 30px;
  background: white;
  border: 1px solid #e2e2e2;
  border-radius: 5px;
  color: #ff7058;
  font-size: 0.65em;
  font-weight: 100;
}
.calendar-filter-text {
  font-weight: 100;
}

@media screen and (max-width: 600px) {
  .float-right {
    float: left !important;
  }
}
</style>
